'use client'

interface Product {
  reference?: string
  sku?: string
  isAvailable?: boolean
  isActive?: boolean
}

interface Order {
  products: Product[]
}

interface ProductsInCart {
  [key: string]: Product
}

interface ProductList {
  sku: string
  isAvailable: boolean
  isActive: boolean
}

interface SuggestedProductsParams {
  productsInCart: ProductsInCart
  productList?: ProductList[]
}

interface ShouldSuggestProductsParams {
  forgotSomethingProducts?: ProductList[]
  timeToSuggest: number
}

const productsSku = (products: ProductsInCart): string[] => {
  return (
    Object.keys(products)
      .map((key) => products[key].reference || products[key].sku)
      .filter((sku): sku is string => sku !== undefined) || []
  )
}

export const getProductsSkuList = (orders: Order[]): string[] => {
  const allProducts = orders.map((order: Order) =>
    order.products
      .filter(({ reference }: Product) => reference)
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      .map(({ reference }: Product) => reference!)
  )

  const result = [...new Set(allProducts.flat())]

  return result
}

export const getSuggestedProducts = ({
  productsInCart,
  productList = [],
}: SuggestedProductsParams): ProductList[] => {
  return productList.reduce((acc: ProductList[], value: ProductList) => {
    const isDuplicated =
      acc.findIndex((item: ProductList) => item.sku === value.sku) >= 0
    const isInCart = productsSku(productsInCart).includes(value.sku)
    const isEnabledProduct = value.isAvailable
    const isActiveProduct = value.isActive
    if (!isDuplicated && !isInCart && isEnabledProduct && isActiveProduct) {
      acc.push(value)
    }
    return acc
  }, [])
}

export const shouldSuggestProducts = ({
  forgotSomethingProducts = [],
  timeToSuggest,
}: ShouldSuggestProductsParams): boolean => {
  const item: string | null = sessionStorage.getItem('lastSuggestionTime')
  const lastSuggestionTime =
    (new Date().getTime() - new Date(item || '').getTime()) / 1000
  const isEnabled =
    Number.isNaN(lastSuggestionTime) || lastSuggestionTime > timeToSuggest

  return isEnabled && forgotSomethingProducts.length > 0
}
